import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Demo() {
  const { enterDemo, isDemo } = useAuth();

  useEffect(() => {
    if (!isDemo) {
      enterDemo();
    }
  }, [isDemo, enterDemo]);

  if (!isDemo) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
        Menyiapkan dashboard demo...
      </div>
    );
  }

  return <Navigate to="/" replace />;
}
